import PropTypes from 'prop-types';
import React from 'react';

import { google } from 'evee-ui-common/services';

import AsyncAutocomplete from '../AsyncAutocomplete';

import OptionView from './OptionView';

function GooglePlacesAutocomplete({
  className,
  value,
  label,
  noOptionsText,
  TextFieldProps,
  InputLabelProps,
  required,
  error,
  helperText,
  classes,
  onChange,
}) {
  const processChange = async (prediction) => {
    try {
      const place = await google.places.getPlaceDetails(prediction.place_id);

      if (!place) {
        return;
      }

      place.description = prediction.description;
      
      onChange(place);
    } catch (error) {
      console.error('Failed to get place details:', error);
    }
  };

  return (
    <AsyncAutocomplete
      requestMethod={google.places.getPlacePredictions}
      value={value}
      className={className}
      displayField="description"
      renderOption={OptionView}
      label={label}
      noOptionsText={noOptionsText}
      TextFieldProps={TextFieldProps}
      InputLabelProps={InputLabelProps}
      required={required}
      error={error}
      helperText={helperText}
      classes={{ input: classes.input }}
      onChange={processChange}
    />
  );
}


GooglePlacesAutocomplete.propTypes = {
  className: PropTypes.string,
  value: PropTypes.shape({}),
  noOptionsText: PropTypes.string,
  label: PropTypes.string,
  TextFieldProps: PropTypes.shape({
    placeholder: PropTypes.string,
  }),
  InputLabelProps: PropTypes.shape({}),
  required: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  classes: PropTypes.shape({ input: PropTypes.string }),
  onChange: PropTypes.func,
};

GooglePlacesAutocomplete.defaultProps = {
  className: '',
  value: {},
  label: null,
  noOptionsText: 'No matching addresses found',
  required: false,
  error: false,
  helperText: '',
  TextFieldProps: {
    placeholder: '',
  },
  InputLabelProps: {},
  classes: {
    input: '',
  },
  onChange: () => {},
};

export default GooglePlacesAutocomplete;
